/**
 * Typo transform
 */
export var TypographyTransform;
(function (TypographyTransform) {
    TypographyTransform["TEXT_CAPITALIZED"] = "is-capitalized";
    TypographyTransform["TEXT_LOWERCASE"] = "is-lowercase";
    TypographyTransform["TEXT_UPPERCASE"] = "is-uppercase";
    TypographyTransform["TEXT_ITALIC"] = "is-italic";
})(TypographyTransform || (TypographyTransform = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwb2dyYXBoeVRyYW5zZm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL29iamVjdHMvVHlwb2dyYXBoeS9UeXBvZ3JhcGh5VHJhbnNmb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksbUJBS1g7QUFMRCxXQUFZLG1CQUFtQjtJQUM3QiwwREFBbUMsQ0FBQTtJQUNuQyxzREFBK0IsQ0FBQTtJQUMvQixzREFBK0IsQ0FBQTtJQUMvQixnREFBeUIsQ0FBQTtBQUMzQixDQUFDLEVBTFcsbUJBQW1CLEtBQW5CLG1CQUFtQixRQUs5QiJ9